module.exports = __webpack_public_path__ + "img/login_old.d6d3bb09.jpg";